import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../_models/user';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  isLoggedIn$: Observable<boolean>;
  user$: Observable<User>;
  token: string;
  tokenString: string;

  currentUser: User;
  users: User[] = [];

  constructor() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    if (this.currentUser != null) {
      this.token = this.currentUser.accessToken;
      this.tokenString = 'Bearer ' + this.token;
    } else {
      this.tokenString = 'Bearer ';
    }
    request = request.clone({
      setHeaders: {
        Authorization: this.tokenString
      }
    });
    return next.handle(request);
  }
}
